// @flow
import React from 'react';

import RoutingEnum from 'constants/RoutingEnum';

// -- actions

// -- stores
import {RouteStore} from 'stores';

// -- entities

// -- views
import AbstractComponent from 'components/AbstractComponent';
import Ariane from 'PMT/components/Ariane';

export default class DashboardHomePage extends AbstractComponent {

  constructor() {
    super();

    this.arianeIcon = 'fa-dashboard';
    this.arianeDetails = [
      {
        name: 'Accueil',
        link: RoutingEnum.DASHBOARD
      }
    ];
  }

  componentDidMount() {
    RouteStore.redirectTo(RoutingEnum.RESTAURANT_EDIT);
  }

  render() {
    return (
      <div className="dashboard_page">

        <Ariane icon={this.arianeIcon} details={this.arianeDetails}/>

      </div>
    );
  }

}
